export default __webpack_public_path__ + "static/media/Halberd of the Ostiary.d61ef9c0.jpg";